import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PiExport } from "react-icons/pi";
import ReadingsReportModal from "./ReadingsReportModal";
import { Button, DatePicker, Tooltip } from "antd";
import {
  AppDispatch,
  getReadingList,
  getReadingListRequest,
  useDynamicSelector,
} from "@src/redux";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";
const { RangePicker } = DatePicker;
interface SelectRangePicker {
  fromDatetime?: Date;
  toDatetime?: Date;
}
const ReadingsHeaderOptions: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const { id } = useParams();
  const [selectRangePicker, setSelectRangePicker] =
    useState<SelectRangePicker>();
  // The range the subject's table was last fetched with. selectRangePicker only
  // drives the picker's display, and is seeded from whatever list is in the store
  // at mount, so it cannot stand in for this.
  const [subjectRange, setSubjectRange] = useState<SelectRangePicker>({});
  const { filter: sidebarFilter } = useDynamicSelector("reading_filter");

  const { result: readingList, loading: readingListLoading } =
    useSelector(getReadingList);
  const openReadingReportModal = () => {
    setIsModalVisible(true);
  };

  // Last Reading is one row per person: the badge counts people with a matching
  // reading, so ranges overlap wherever a person was screened in more than one.
  const isLastReadingView = !id && !!sidebarFilter?.showOnlyLastReadingOfSubject;

  const handleChange = (date: any) => {
    // set_select_range_picker({
    //   from_datetime: date?.[0],
    //   to_datetime: date?.[1],
    // });
    setSelectRangePicker({
      fromDatetime: date?.[0]?.toISOString(),
      toDatetime: date?.[1]?.toISOString(),
    });
    setSubjectRange({
      fromDatetime: date?.[0]?.toDate(),
      toDatetime: date?.[1]?.toDate(),
    });
    dispatch(
      getReadingListRequest({
        filter: {
          subjectId: id || "",
          fromDatetime: date?.[0],
          toDatetime: date?.[1],
        },
        sort: [
          {
            field: "datetime",
            order: "desc",
          },
        ],
      })
    );
  };

  useEffect(() => {
    if (readingList?.items && readingList?.items?.length > 0 && id) {
      setSelectRangePicker({
        fromDatetime: readingList.items[0]?.datetime,
        toDatetime:
          readingList.items[readingList.items.length - 1]?.datetime,
      });
    }
  }, []);

  useEffect(() => {
    setSubjectRange({});
  }, [id]);

  return (
    <div className="analysis-card-header-title-container">
      <div className="readings-table-header">
        <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
          <div style={{ display: "flex", gap: "20px" }}>
            <Tooltip
              title={isLastReadingView ? t("latest_readings_hint") : undefined}
            >
              <div className="reading-count-label">
                {isLastReadingView ? t("latest_readings") : t("readings")}
              </div>
            </Tooltip>
            <div className="reading-count-box">
              {readingList?.pagination?.totalCount ??
                readingList?.items?.length ??
                0}
            </div>
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            {id && (
              <RangePicker
                className="subject-details-range-picker"
                // renderExtraFooter={() => "extra footer"}
                value={[
                  dayjs(selectRangePicker?.fromDatetime),
                  dayjs(selectRangePicker?.toDatetime),
                ]}
                onChange={handleChange}
                format={"DD-MMM-YYYY"}
              />
            )}
            <Tooltip title={t("export") || "Export"}>
              <Button
                type="default"
                shape="default"
                icon={<PiExport size={18} />}
                onClick={openReadingReportModal}
                className="readings-export-button"
              />
            </Tooltip>
          </div>
        </div>
        <ReadingsReportModal
          isModalVisible={isModalVisible}
          setIsModalVisible={setIsModalVisible}
          filter={id ? { subjectId: id, ...subjectRange } : sidebarFilter}
        />
      </div>
    </div>
  );
};

export default ReadingsHeaderOptions;
